import { StatusText } from '../../styles'
import { getTextColorByStatus } from '../../utils'
import { PAYMENT_STATUS, SLIP_STATUS, UNASSIGNED_TIME } from '../../constants'
import styled from 'styled-components'
import ActionBox from './ActionBox'

const Slip = ({ slip, onClickApprove, onClickReject, onClickRecheck, isReadOnly = false }) => {
  const status = slip?.status === PAYMENT_STATUS.IN_PROGRESS ? slip.inProgress : slip.status

  return (
    <Container>
      {slip.imageURL ? (
        <img
          src={slip.imageURL}
          alt="slip"
          style={{
            width: '100%',
          }}
        />
      ) : (
        <div />
      )}
      <div>
        <div>
          <span>ประเภท: </span>
          <span>{slip.type}</span>
        </div>
        <div>
          <span>สถานะ: </span>
          <StatusText color={getTextColorByStatus(status)}>{status}</StatusText>
        </div>
        <div>
          <span>จำนวนที่อ่านได้: </span>
          <span style={{ color: 'red', fontWeight: 600, fontSize: '1.25rem' }}>
            {Number(slip.amount).toLocaleString()}
          </span>
          <span> บาท</span>
        </div>
        <div>
          <span>สถานะการตรวจสลิป: </span>
          <span>{slip.detail.remark}</span>
        </div>
        <div>
          <span>หมายเลขอ้างอิง: </span>
          <span>{slip.detail.slip.transRef || '-'}</span>
        </div>
        {slip.type === 'QR_CODE' && slip.status === SLIP_STATUS.COMPLETE && (
          <div>
            <span>หมายเลขอ้างอิง2: </span>
            <span>{slip.detail.slip.ref2 || '-'}</span>
          </div>
        )}
        <div>
          <span>อัปโหลดเมื่อ: </span>
          <span>{new Date(slip.createdAt).toLocaleString('th-TH')}</span>
        </div>
        <div>
          <span>ตรวจสลิปเมื่อ: </span>
          <span>{slip.updatedAt === UNASSIGNED_TIME ? '-' : new Date(slip.updatedAt).toLocaleString('th-TH')}</span>
        </div>
        {slip.detail.solvedBy.userName && (
          <div>
            <span>ตรวจสลิปโดย: </span>
            <span>{slip.detail.solvedBy.userName}</span>
          </div>
        )}
        {isReadOnly ? null : (
          <ActionBox
            slip={slip}
            onClickApprove={onClickApprove}
            onClickReject={onClickReject}
            onClickRecheck={onClickRecheck}
          />
        )}
      </div>
    </Container>
  )
}

export default Slip

const Container = styled.div`
  width: 100%;
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr 1fr;
`
